import {LogLevel} from "../app/services/logger/log-level.enum";

export const environment = {
  dev: false,
  test: true,
  staging: false,
  production: false,
  ironBackupViewer: false,
  loglevel: LogLevel.DEBUG,
  i18n: {
    langs: ['en', 'de'],
    defaultLang: 'en',
    defaultCountry: 'DE',
    storageKey: 'i18n:selected_language',
    storageUse: true,
    browserUse: true
  },
  tolgee: {
    enable: false,
    url: '',
    projectId: -1,
    token: ''
  },
  repository: 'api',
  api: {
    ping: {
      enabled: true,
      initial: 1000,
      interval: 60000
    },
    logging: {
      enabled: true,
      interval: 30000,
      loglevel: LogLevel.INFO
    },
    core: {
      schema: 'https',
      hostname: 'acc-core-test.wip.ge',
      port: 443,
      path: ['api']
    }
  },
  cache: {
    enabled: true
  },
  support: {
    /* Master-Switch für den Support über Zammad im FE (Widget, Ticket-Buttons, Ticket-Liste) */
    enabled: true,
    list: true
  }
};
